<template>
  <div id="bookAppointment" class="relative pb-10">
    <img src="@/assets/images/shared/starGroupIconLightBrownRightSmall.svg" style="width: 9.5vw; top: 5%" class="absolute right-0 -z-10" />
    <img src="@/assets/images/shared/starGroupIconLightBrownLeftSmall.svg" style="width: 7vw; bottom: 5%" class="absolute left-0 -z-10" />

    <ContactBtnGrp phoneNo="+85237233063" phoneDisplayNo="+852 3723 3063" whatsappNo="85237260622" whatsappDisplayNo="+852 3726 0622" />

    <div id="bookAppointmentForm" class="pt-10 hidden">
      <title-w-star :title="t('bookYourAppointment.bookAppointment')" titleColor="#603813" :starIconObj="{ componentName: 'shared', imgName: 'starIconGreen', imgFormat: 'svg' }" />
      <div id="bookAppointmentFormFrame" class="font-jost bg-grey-background m-14 p-20 rounded-3xl text-lg">
        <Form ref="bookAppointmentForm" id="bookAppointmentForm" @submit="sendMsg" :validation-schema="schema">
          <div class="flex space-x-14 items-center">
            <label class="radio-container"
              >{{ t("bookYourAppointment.existingPatient") }}
              <input type="radio" name="patientType" value="existingPatient" v-model="patientType" />
              <span class="checkmark"></span>
            </label>
            <label class="radio-container"
              >{{ t("bookYourAppointment.newPatient") }}
              <input type="radio" name="patientType" value="newPatient" v-model="patientType" />
              <span class="checkmark"></span>
            </label>
            <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="patientTypeError">{{ patientTypeError }}</span>
          </div>
          <div class="flex space-x-14 pt-10">
            <span class="w-1/3 flex items-center">
              <span>{{ t("bookYourAppointment.salutation") }}</span>
              <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="salutationError">{{ salutationError }}</span>
            </span>
            <span class="w-1/3 flex items-center">
              <span>{{ t("bookYourAppointment.firstName") }}*</span>
              <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="firstNameError">{{ firstNameError }}</span>
            </span>
            <span class="w-1/3 flex items-center">
              <span>{{ t("bookYourAppointment.lastName") }}*</span>
              <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="lastNameError">{{ lastNameError }}</span>
            </span>
          </div>
          <div class="flex space-x-14">
            <select name="salutation" id="salutation" v-model="salutation" class="border border-input-border rounded px-3 h-12 w-1/3" style="border-width: 1px">
              <option value="">{{ t("common.pleaseSelect") }}</option>
              <template v-for="(item, index) in bookYourAppointmentStore.form.salutationList" :key="'salutation' + index">
                <option :value="t(item)">{{ t(item) }}</option>
              </template>
            </select>
            <input v-model="firstName" type="text" name="firstName" class="border border-input-border rounded px-3 h-12 w-1/3" />
            <input v-model="lastName" type="text" name="lastName" class="border border-input-border rounded px-3 h-12 w-1/3" />
          </div>
          <div class="flex space-x-14 pt-10">
            <span class="w-1/3 flex items-center"
              ><span>{{ t("bookYourAppointment.phoneNumber") }}*</span>
              <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="phoneNumberError">{{ phoneNumberError }}</span>
            </span>
            <span class="w-1/3 flex items-center"
              ><span>{{ t("bookYourAppointment.emailAddress") }}*</span> <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="emailAddressError">{{ emailAddressError }}</span>
            </span>
            <span class="w-1/3 flex items-center"
              ><span>{{ t("bookYourAppointment.preferredLocation") }}*</span> <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="preferredLocationError">{{ preferredLocationError }}</span>
            </span>
          </div>
          <div class="flex space-x-14">
            <input v-model="phoneNumber" type="text" name="phoneNumber" class="border border-input-border rounded px-3 h-12 w-1/3" />
            <input v-model="emailAddress" type="text" name="emailAddress" class="border border-input-border rounded px-3 h-12 w-1/3" />
            <select name="preferredLocation" id="preferredLocation" v-model="preferredLocation" class="border border-input-border rounded px-3 h-12 w-1/3 drop-down-group" style="border-width: 1px">
              <option value="" disabled>{{ t("common.pleaseSelect") }}</option>

              <template v-for="(group, index) in bookYourAppointmentStore.form.preferredLocationList" :key="'preferredLocationGroup' + index">
                <option :value="t(group.group)" disabled class="group-name">{{ t(group.group) }}</option>

                <template v-for="(location, locationIdx) in group.locationList" :key="'preferredLocation' + locationIdx">
                  <option :value="t(location)" class="group-item">{{ "&nbsp &nbsp" }}{{ t(location) }}</option>
                </template>
              </template>
            </select>
          </div>
          <div class="flex space-x-14 pt-10">
            <span class="w-1/3 flex items-center"
              ><span>{{ t("bookYourAppointment.serviceCategory") }}</span>
              <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="serviceCategoryError">{{ serviceCategoryError }}</span>
            </span>
            <span class="w-1/3 flex items-center"
              ><span>{{ t("bookYourAppointment.date") }}*</span> <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="dateError">{{ dateError }}</span>
            </span>
            <span class="w-1/3 flex items-center"
              ><span>{{ t("bookYourAppointment.timeslot") }}*</span> <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="timeslotError">{{ timeslotError }}</span>
            </span>
          </div>
          <div class="flex space-x-14">
            <select name="serviceCategory" id="serviceCategory" v-model="serviceCategory" class="border border-input-border rounded px-3 h-12 w-1/3" style="border-width: 1px">
              <option value="">{{ t("common.pleaseSelect") }}</option>
              <template v-for="(item, index) in bookYourAppointmentStore.form.serviceCategoryList" :key="'serviceCategory' + index">
                <option :value="t(item)">{{ t(item) }}</option>
              </template>
            </select>
            
            <!-- <el-config-provider :locale="zhCn">
            </el-config-provider>-->
            <el-date-picker v-model="date" type="date" :placeholder="t('common.pleaseSelect')" format="YYYY/MM/DD" value-format="YYYY-MM-DD" :disabled-date="disabledDate" class="border border-input-border rounded !h-12" style="width: 33.333333%; color: black" @change="changeDate" />
            <select name="timeslot" id="timeslot" v-model="timeslot" class="border border-input-border rounded px-3 h-12 w-1/3" style="border-width: 1px">
              <option value="" disabled>{{ t("common.pleaseSelect") }}</option>
              <template v-for="(item, index) in bookYourAppointmentStore.form.timeslotList" :key="'timeslot' + index">
                <option :value="item">{{ item }}</option>
              </template>
            </select>
          </div>

          <!-- <button-util buttonType="submit" bgColor="#603813" label="bookYourAppointment.bookAppointment" class="mt-10" /> -->
        </Form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHeaderStore } from "@/stores/header";
import { useBookYourAppointmentStore } from "@/stores/bookYourAppointment";
import { computed, onMounted, ref, toRefs } from "vue";
import { useForm, useField } from "vee-validate";
import { object, string } from "yup";
import { useRouter } from "vue-router";
import { useCommonStore } from "@/stores/common";
import moment from "moment";
import { useI18n } from "vue-i18n";
import ContactBtnGrp from "@/components/shared/ContactBtnGrp.vue";
//import zhCn from "element-plus/lib/locale/lang/zh-cn";

const headerStore = useHeaderStore();
const bookYourAppointmentStore = useBookYourAppointmentStore();
const commonStore = useCommonStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  if( headerStore.scrollToAppointmentForm == true) 
    scrollTo(0, 650);
  
  headerStore.scrollToAppointmentForm = false;
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const changeDate = () => {
  console.log("dateChanged: " + commonStore.publicHolidayList.find((element) => element.unix == moment(date.value).format("x")) != undefined);
  timeslot.value = "";
  if (commonStore.publicHolidayList.find((element) => element.unix == moment(date.value).format("x")) != undefined) {
    console.log("not allow to select public holiday");
    date.value = "";
    return;
  }
  //calulcate the timeslot availabl
  let startTime = "";
  let endTime = "";
  let lunchStartTime = "";
  let lunchEndTime = "";
  let haveLunchTime = true;
  let appointmentTimeslot = commonStore.openingHours.appointmentTimeslot;
  if (moment(date.value).isoWeekday() == 6) {
    startTime = commonStore.openingHours.saturday.startTime;
    endTime = commonStore.openingHours.saturday.endTime;
    haveLunchTime = false;
  } else {
    startTime = commonStore.openingHours.weekdays.startTime1;
    endTime = commonStore.openingHours.weekdays.endTime2;
    lunchStartTime = commonStore.openingHours.weekdays.startLunchTime;
    lunchEndTime = commonStore.openingHours.weekdays.endLunchTime;
  }
  bookYourAppointmentStore.form.timeslotList = [];
  bookYourAppointmentStore.form.timeslotList = bookYourAppointmentStore.availableTimeslot(appointmentTimeslot, startTime, endTime, lunchStartTime, lunchEndTime, true);
};

const disabledDate = (time: Date) => {
  //disable hk public holiday
  // commonStore.publicHolidayList.find((element) => element.unix == time.getTime()) ||
  return commonStore.publicHolidayList.find((element) => element.unix == time.getTime()) || moment(time).isoWeekday() == 7;
};

const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;
// Define a validation schema
const schema = computed(() => {
  return object({
    patientType: string().required(t("bookYourAppointment.patientTypeRequired")),
    salutation: string(),
    firstName: string().required(t("bookYourAppointment.firstNameRequired")),
    lastName: string().required(t("bookYourAppointment.lastNameRequired")),
    phoneNumber: string().required(t("bookYourAppointment.phoneNumberRequired")).matches(phoneRegExp, t("bookYourAppointment.phoneNumberInvalid")),
    emailAddress: string().required(t("bookYourAppointment.emailRequired")).email(),
    preferredLocation: string().required(t("bookYourAppointment.preferredLocationRequired")),
    serviceCategory: string(),
    date: string().nullable().required(t("bookYourAppointment.dateRequired")),
    timeslot: string().nullable().required(t("bookYourAppointment.timeslotRequired")),
  });
});
// Create a form context with validation schema
const { handleSubmit, isSubmitting, meta } = useForm({
  validationSchema: schema,
  initialValues: {
    patientType: "existingPatient",
    salutation: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    emailAddress: "",
    preferredLocation: "",
    serviceCategory: "",
    date: "",
    timeslot: "",
  },
});

const { value: patientType, errorMessage: patientTypeError } = useField<string>("patientType");
const { value: salutation, errorMessage: salutationError } = useField<string>("salutation");
const { value: firstName, errorMessage: firstNameError } = useField<string>("firstName");
const { value: lastName, errorMessage: lastNameError } = useField<string>("lastName");
const { value: phoneNumber, errorMessage: phoneNumberError } = useField<string>("phoneNumber");
const { value: emailAddress, errorMessage: emailAddressError } = useField<string>("emailAddress");
const { value: preferredLocation, errorMessage: preferredLocationError } = useField<string>("preferredLocation");
const { value: serviceCategory, errorMessage: serviceCategoryError } = useField<string>("serviceCategory");
const { value: date, errorMessage: dateError } = useField<string>("date");
const { value: timeslot, errorMessage: timeslotError } = useField<string>("timeslot");

const sendMsg = handleSubmit(async (values, actions) => {
  if (commonStore.publicHolidayList.find((element) => element.unix == moment(date.value).format("x")) != undefined) {
    console.log("not allow to select public holiday");
    date.value = "";
    timeslot.value = "";
    return;
  }
  console.log("sendMsg");
  let detail = {
    contactEntryPoint: headerStore.routerName,
    patientType: patientType.value == "existingPatient" ? "Existing Patient" : "New Patient",
    salutation: salutation.value,
    firstName: firstName.value,
    lastName: lastName.value,
    phoneNumber: phoneNumber.value,
    emailAddress: emailAddress.value,
    preferredLocation: preferredLocation.value,
    serviceCategory: serviceCategory.value,
    date: date.value,
    timeslot: timeslot.value,
  };

  detail.message =
    "Patient Type: " +
    detail.patientType +
    "<br />" +
    "Salutation: " +
    detail.salutation +
    "<br />" +
    "First Name: " +
    detail.firstName +
    "<br />" +
    "Last Name: " +
    detail.lastName +
    "<br />" +
    "Phone Number: " +
    detail.phoneNumber +
    "<br />" +
    "Email Address: " +
    detail.emailAddress +
    "<br />" +
    "Preferred Location: " +
    detail.preferredLocation +
    "<br />" +
    "Service Category: " +
    detail.serviceCategory +
    "<br />" +
    "Date: " +
    detail.date +
    "<br />" +
    "Timeslot: " +
    detail.timeslot +
    "<br />";

  //replace \n to <br> for new line
  var isSuccess = await bookYourAppointmentStore.bookAppointment(detail);
  console.log("isSuccess?" + isSuccess);
  if (isSuccess) actions.resetForm();
});
</script>

<style scoped>
.el-input {
  width: 33.333333% !important;
}
.drop-down-group .group-name {
  color: #c4c4c4;
}
</style>